module.exports = __webpack_public_path__ + "img/brochure-specs.cc708d64.png";